import { Flex, Modal } from "antd";
import React from "react";
import Title from "antd/es/typography/Title";

import { useTranslation } from "react-i18next";
import { colors } from "../../../../../../constants/colors";
import { CustomTitle } from "../../../../../common/customTitle";

const ViewBankDetails = ({ open, onClose, data }) => {
  /* translation dependencies */
  const { t } = useTranslation();

  return (
    <Modal open={open} onCancel={onClose} footer={false}>
      <Flex
        vertical
        gap="2rem"
        align="center"
        justify="center"
        style={{ padding: "30px 0px" }}
      >
        <CustomTitle
          justifyContent="center"
          style={{ color: colors.primaryColor }}
        >
          {t("payoutDetails")}
        </CustomTitle>

        <Title level={3} type="secondary">
          <p>
            {t("accountHolderName", { accountHolderName: data?.account_holder_name})}
          </p>
          <p>{t("accountNumber", { accountNumber: data?.account_number })}</p>
          <p>{t("bankCode", { bankCode: data?.bank_code })}</p>
          <p>{t("bankName", { bankName: data?.bank_name })}</p>
          <p>{t("routingNumber", { routingNumber: data?.routing_number })}</p>
          <p>{t("swiftCode", { swiftCode: data?.swift_code })}</p>
        </Title>
      </Flex>
    </Modal>
  );
};

export default ViewBankDetails;
